
import React from "react";
import { ChartContainer } from "@/components/ui/chart";
import { LineChart, Line, ResponsiveContainer, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from "recharts";

interface UserChartProps {
  data: {
    name: string;
    "Total de Usuários": number;
    "Usuários Premium": number;
  }[];
}

const UserChart: React.FC<UserChartProps> = ({ data }) => {
  return (
    <ChartContainer config={{
      users: { label: "Total de Usuários", color: "rgb(59, 130, 246)" },
      premium: { label: "Usuários Premium", color: "rgb(139, 92, 246)" },
    }}>
      <ResponsiveContainer width="100%" height="100%">
        <LineChart 
          data={data}
          margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis />
          <Tooltip />
          <Legend />
          <Line 
            type="monotone" 
            dataKey="Total de Usuários" 
            stroke="rgb(59, 130, 246)" 
            strokeWidth={2}
            activeDot={{ r: 8 }} 
          />
          <Line 
            type="monotone" 
            dataKey="Usuários Premium" 
            stroke="rgb(139, 92, 246)" 
            strokeWidth={2}
          />
        </LineChart>
      </ResponsiveContainer>
    </ChartContainer>
  );
};

export default UserChart;
